import { defineMiddleware } from '../middleware'
import { useAuthStore } from '@/features/auth'

defineMiddleware('role', (to) => {
  const requiredRoles = to.meta.roles

  if (!requiredRoles || requiredRoles.length === 0) {
    if (import.meta.env.DEV) {
      console.warn(`[Router] Route "${to.path}" has 'role' middleware but no meta.roles defined`)
    }
    return { path: '/forbidden' }
  }

  const userRole = useAuthStore().user?.role

  if (!userRole || !requiredRoles.includes(userRole)) {
    return { path: '/forbidden' }
  }

  return true
})
